module.exports = __webpack_public_path__ + "img/Touch.a0a34914.png";